import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames                                                   from 'classnames';
import DV                                                           from 'ts-data-validator';

import { staticPageConstants } from '../../../../common/constants/staticPageConstants';
import useEventListener        from '../../../../common/hooks/useEventListener';

const RouterNav = function(props) {
  const {
          active,
          changeState,
          changeTab,
          label,
          nav,
          open,
          style,
        } = props;

  const [visibleRange, setVisibleRange] = useState({
    start: 0,
    end:   2,
  });
  const [isMobile, setIsMobile]         = useState(false);

  const selectedRef = useRef(null);
  const optionsRef  = useRef(null);

  const visibleTabs = useMemo(() => {
    if (style === 'TABS' || style === 'BUTTONS') {
      return isMobile
        ? Object.values(nav)
          .slice(visibleRange.start, visibleRange.end)
        : Object.values(nav);
    } else {
      return Object.values(nav);
    }
  }, [nav, visibleRange, isMobile]);

  const handleResize = useCallback(() => {
    const { screen: { width } } = window;
    if (width <= 990) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  if (!isSSR()) {
    useEventListener('resize', handleResize);
  }

  const handleChangeTab = useCallback((event, index) => {
    if (active !== index) {
      handleChangeState(event);

      changeTab(index);
    }
  }, [active]);

  const handleClickOutside = useCallback((event) => {
    if (
      open &&
      (
        optionsRef.current && !optionsRef.current.contains(event.target)) ||
      (
        selectedRef.current && !selectedRef.current.contains(event.target))
    ) {
      handleChangeState(event);
    }
  }, [open]);

  const calculateVisibleRange = useCallback((index) => {
    if (index === 0) {
      setVisibleRange({
        start: index,
        end:   2,
      });
    } else if (index >= nav.length - 1) {
      setVisibleRange({
        start: index - 1,
        end:   index + 1,
      });
    } else if (index > visibleRange.start) {
      setVisibleRange({
        start: index,
        end:   index + 2,
      });
    } else if (index < visibleRange.end) {
      setVisibleRange({
        start: index - 1,
        end:   index + 1,
      });
    }
  }, [nav.length, visibleRange]);

  const handleTabClick = useCallback((event, index) => {
    calculateVisibleRange(index);
    handleChangeTab(event, index);
  }, [visibleRange, handleChangeTab, calculateVisibleRange]);

  const handleChangeState = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    if (open) {
      changeState(false);
    } else {
      changeState(true);
    }
  }, [open]);



  useEffect(() => {
    if (open) {
      if (!isSSR()) {
        document.addEventListener('click', handleClickOutside);
      }
    } else {
      if (!isSSR()) {
        document.removeEventListener('click', handleClickOutside);
      }
    }

    return () => {
      if (!isSSR()) {
        document.removeEventListener('click', handleClickOutside);
      }
    };
  }, [open]);

  useEffect(() => {
    if (style === 'TABS' || style === 'BUTTONS') {
      calculateVisibleRange(active);
    }

    if (!isSSR()) {
      handleResize();
    }
  }, []);

  return (
    <div className={classNames('tabs-select', { open })}>
      {DV.isNotEmptyString(label) && (
        <div className={'title'}>{label}</div>
      )}
      <div
        ref={selectedRef}
        className={'selected'}
        onClick={handleChangeState}
        title={style === staticPageConstants.COMPONENTS.TABS_WITH_ROUTER.SETTINGS.STYLE.SELECT
          ? Object.values(nav)[active]
          : null}
      >
        {Object.values(nav)[active]}
        <span className={'ic-arrow-bottom'} />
      </div>
      <div className={'body'}>
        <ul ref={optionsRef} className={'tabs basic-tabs'}>
          {visibleTabs && visibleTabs.map((tab, tabIndex) => (
            <li
              key={tabIndex}
              className={classNames({
                'active': active === (
                  isMobile && style === 'TABS' ? (
                    tabIndex + visibleRange.start) : tabIndex),
              })}
              onClick={(event) => {
                if (isMobile && style === 'TABS') {
                  handleTabClick(event, tabIndex + visibleRange.start);
                } else {
                  handleTabClick(event, tabIndex);
                }
              }}
              title={style === staticPageConstants.COMPONENTS.TABS_WITH_ROUTER.SETTINGS.STYLE.SELECT ? tab : null}
            >{tab}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RouterNav;